import * as signalR from "@microsoft/signalr";
import { formCallback } from "./formCallback";
import { env, isDevelopment, useMainStore } from "@/store";

class Signalr {
  // 重连次数
  relinkNumber = 1;
  maxRelinkNumber = 2;
  relinkInterval = 5000;
  // 主体
  connection: any;
  token = "";
  isStop = false;

  random = 0;
  params?: Record<string, string> = {};
  constructor(token: string, params?: Record<string, string>) {
    this.setToken(token, params);
  }
  setToken(token: string, params?: Record<string, string>) {
    this.token = token;
    this.params = params;

    this.isStop = true;
    this.connection?.stop();
    this.link();
  }
  // 建立连接
  private link() {
    const url = this.getUrl();

    // let Url_params = getUrlParams(this.params);
    // console.log(url + Url_params);
    this.connection = new signalR.HubConnectionBuilder()
      .withUrl(url + (env.MODE == "test" ? "/chatHub/" : ""), {
        accessTokenFactory: () => this.token,
      })
      .build();
    formCallback(this.connection);
    this.eventClose();
    this.start();
  }
  // 掉线监听
  private eventClose() {
    this.connection.onclose(async () => {
      if (this.isStop) return;
      console.log("-----------------------------------------------signalr掉线-----------------------------------------------");
      this.againLink();
    });
  }
  // 重连
  private againLink() {
    if (this.relinkNumber >= this.maxRelinkNumber) return false;
    this.relinkNumber++;
    this.link();
  }
  private async start() {
    try {
      await this.connection.start();
      this.relinkNumber = 1;
      this.isStop = false;
    } catch {
      setTimeout(this.start, this.relinkInterval);
    }
  }
  getUrl() {
    const mainStore = useMainStore();
    const signalrArr = mainStore.getSignalrArr;
    this.random = signalrArr.length == 1 ? 0 : this.getRandom(signalrArr.length);
    if (isDevelopment) return "/signalr";
    return signalrArr[this.random];
  }
  getRandom(len = 0): number {
    let random = Math.floor(Math.random() * len);
    if (this.random == random) return this.getRandom(len);
    else return random;
  }
}
let instance: any;

export default (token: string, params?: Record<string, string>) => {
  if (token == instance?.token) return;
  if (instance) instance.setToken(token, params);
  else instance = new Signalr(token, params);
  return instance;
};
